import axios from 'axios'
import { URL } from '../../util/ambienteActions';

const baixarComprovanteReembolso = (base64Comprovante, nomeComprovante) => axios({
    url:`${URL}/arquivo/id/${base64Comprovante}/nome/${nomeComprovante}/baixar`,
    method: 'GET',
    responseType: 'blob'
    })

export default baixarComprovanteReembolso